import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';

@Component({
  selector: 'app-view-task-management',
  templateUrl: './view-task-management.component.html',
  styleUrls: ['./view-task-management.component.css']
})
export class ViewTaskManagementComponent implements OnInit {
  @ViewChild('attachInput') attachInputRef: any;
  @Input() taskId: string;
  @Input() businessID: string;
  
  rowData: any;
  taskDetails: any = {
    task_name: ''
  };
  taskDescription: any = {
    message: ''
  };

  frequency = {
    frequency: {},
    due_days: {}
  }
 
  messages = [];
  internalComments = [];

  profile_images = {};
  aboutBusiness = 'All';
  supportedDocType = '';
  supporetsFiles = '';
  supportMaxFileSize = '';
  newMessage = '';
  listBiz = [];
  isLoading = false;
   AttachFiles = [];
   attachNames = [];
   sharedDoc: FormGroup;
   addButton=false;
   listBizTotal=0;
   max_file_count=0;
   supportedFile={
    maxSize:'',
    fileSize:0,
    type:''
  };
  message;
  from_date:any;
  to_date:any;
  pageNo=1;

   searchinput: FormGroup;
   inputDesc: FormGroup;
   inputTaskName: FormGroup;
   singleTaskStatus: any;
   recurringTaskStatus: any;
   task_status = '';
   assignee = '';
   due_date = '';
   userList = [];
   minDate = new Date();
   FromDate = new Date();
   selectedIndex = 0;
   isEditing: boolean = false;
   isEditingDesc: boolean = false;
   title = '';
   discription = '';

   start_date = '';
   fromFrequency = '';
   form_recurring_due_days = '';
   assign_bp_business_id = '';
   stateData: any;

  constructor(private route: ActivatedRoute
    , private router: Router
    , private _utils: UtilitiesService
    , private _api: ApiService
    , private spinner: NgxSpinnerService
    , private formBuilder: FormBuilder
  ) {
    this.searchinput = this.formBuilder.group({
      task_status: new FormControl(''),
      assignee: new FormControl(''),
      due_date: new FormControl(''),
      start_date: new FormControl(''),
      fromFrequency: new FormControl(''),
      form_recurring_due_days: new FormControl(''),
    });

    this.inputDesc = this.formBuilder.group({
      discription: [this.taskDescription.message, Validators.required]
    });

    this.inputTaskName = this.formBuilder.group({
      title: [this.taskDetails.task_name, Validators.required]
    });

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.businessID = navigation.extras.state['data'];
    }
  }
  @Output() back = new EventEmitter<void>();

  goBack() {
    this.back.emit();
  }

  ngOnInit(): void {
    this.getSupportedFiles();
    // this.taskID = this.route.snapshot.paramMap.get('id');
    // const storedState = localStorage.getItem('stateData');
    // if (storedState) {
    //   this.stateData = JSON.parse(storedState);
    //   this.current_bp_business_id = this.stateData['business_id'];
    // }

    this.getTaskDetails();
  }

  resetTabs() {
    this.rowData = '';
  }

getTaskDetails() {
  if (!this.businessID) {
    return;
  }
  const apiData = {
    bp_business_id: this.businessID,
    tm_task_id: this.taskId,
  };
  this.spinner.show();
  this._api.functionPOST('task/getTask', apiData).subscribe((response) => {
    this.taskDetails = response['data']['task'];
    this.taskDescription = response['data']['description'][0];
    this.messages = response['data']['messages'];
    this.internalComments = response['data']['internalComments']
    this.assign_bp_business_id = response['data']['task']['assign_bp_business_id'];
    const responseEdit = {
        task_status: response['data']['task']['status']
      , assignee: response['data']['task']['assign_um_user_id']
      , due_date: response['data']['task']['due_date']
      , start_date: response['data']['task']['recur_start_date']
      , fromFrequency: response['data']['task']['recur_freq_tm_frequency_id']
      , form_recurring_due_days: response['data']['task']['recur_due_tm_days_id']
    };
    this.searchinput.patchValue(responseEdit);
    
    const userlist = [];
      this.messages.map((x) => {
        if (!userlist.includes(x.createdby)) {
          userlist.push(x.createdby);
          this.getProfilePhoto(x['createdby']);
        }
      });
      // this.getUserList();
  });
 
  this.spinner.hide();
}

changeTab(event) {
  this.selectedIndex=event['index'];
  if(this.selectedIndex === 1) {
    this.getTaskDetails();
  const userlist = [];
    this.internalComments.map((x) => {
      if (!userlist.includes(x.createdby)) {
        userlist.push(x.createdby);
        this.getProfilePhoto(x['createdby']);
      }
    });
  }
}

deleteAttachment(data){
  const apiData = {
    current_bp_business_id: this.businessID
  , attachment_id: data['tm_message_attachment_id']
  }
  this.spinner.show();
  this._api.functionPOST('task/deleteAttachement', apiData).subscribe((response) => {
    if (response.success) {
      this._api.openSnackBar(response['data'], 'Success');
      this.getTaskDetails();
    }
  });
  this.spinner.hide();
}

getDate(x){
  return(formatDate(new Date(x), 'yyyy-MM-dd', 'en'));
}

getProfilePhoto(data) {
  let addImage = true;
  if(Object.keys(this.profile_images).includes(data)){
    if(this.profile_images[data].includes('X-Amz-Date')) {
      let currDate = new Date();
      let expStr = this.profile_images[data].split('&').find(x => x.startsWith('X-Amz-Date')).split('=')[1];
      let expSecs = this.profile_images[data].split('&').find(x => x.startsWith('X-Amz-Expires')).split('=')[1];
      let newExpStr = expStr.substring(0, 4) + '-' + expStr.substring(4, 6) + '-' + expStr.substring(6, 11) + ':' +
        expStr.substring(11, 13) + ':' + expStr.substring(13, 16);
      let expDate = new Date(Date.parse(newExpStr));
      expDate.setSeconds(expDate.getSeconds() + +expSecs);
      addImage = currDate > expDate;
    } else {
      addImage = false
    }
  }
  if (addImage) {
    this.profile_images[data] = '';
    this._api.fileReader('user/getUserImagebyId', { um_user_id: data }).subscribe((response) => {
      this.profile_images[data] = this._utils.getImageURL(response);
     }, err => {});
  }
}
downLoad(data) {
  if(data.av_overall_infected=='Y'){
    this._api.openSnackBar("You can't download this file", 'Error');
    return;
  }
  const url = 'task/attachment/' + data['tm_message_attachment_id'];
  this._api.downloadFile(url,'?');
}

removeAttach(i) {
  this.AttachFiles.splice(i, 1);
   this.attachNames.splice(i, 1);
 }
 getSupportedFiles() {
  this._utils.supportedUploadTypesData.subscribe(res => {

    if (res ) {
        const files   =  res['supported_file_types'];
        this.supportedDocType = files.split(',');
      }
      var size = (res['max_file_size_bytes']/1000000)+' MB';
      this.supportedFile={
        maxSize:size,
        fileSize:res['max_file_size_bytes'],
        type:res['supported_file_types']
      };
      this.max_file_count = parseInt(res['max_file_count'])
     this.supporetsFiles = '* Supported document types are ' + this.supportedFile['type'];
     this.supportMaxFileSize = '* Supported maximum file count is '+ this.max_file_count +
     ' and file size is ' + this.supportedFile['maxSize'];
    }
  );
}

 addFileComment(event: any) {
  if(this.AttachFiles.length>=this.max_file_count){
    this._api.openSnackBar('Supported maximum file count should be less than or equal to '+this.max_file_count, 'Error');
    return;
  }
  for (let i = 0; i <= event.target.files.length - 1; i++) {

    const file = event.target.files[i];
    if (file) {
      const extn = file.name.split('.').pop();
            if (this.supportedDocType.includes(extn.toLowerCase())) {
        if (file.size > this.supportedFile['fileSize']) {
          this._api.openSnackBar('Size should be less than '+this.supportedFile['maxSize'], 'Error');
          this.attachInputRef.nativeElement.value = '';
        return false;
        }
            } else {
              event.target.value='';
  this._api.openSnackBar('File not supported', 'Error');
   this.attachInputRef.nativeElement.value = '';
  return false;
}
    }
const selectedFile = event.target.files[i];
if(this.AttachFiles.length>=this.max_file_count){
  this._api.openSnackBar('Supported maximum file count should be less than or equal to '+this.max_file_count, 'Error');
  return;
}
this.AttachFiles.push(selectedFile);
this.attachNames.push(selectedFile.name);
}
this.attachInputRef.nativeElement.value = '';
}

addComment(is_internal?) {
  // if(this.addButton){
  //   return;
  // }
  // this.addButton=true;
  const apiData = new FormData();
  // if (this.newMessage.trim() === '' || !this.newMessage) {
if (this.newMessage.trim() === ''  && this.AttachFiles.length === 0) {
   this._api.openSnackBar('Please enter a comment or add at least 1 attachment.', 'Error');
  //  this.addButton=false;
   return;
 }
 this.spinner.show();
 this.from_date=null;
  this.to_date=null;
   apiData.append('bp_business_id', this.businessID);
 apiData.append('tm_task_id', this.taskId);
apiData.append('tm_message', this.newMessage);
 if (this.AttachFiles.length > 0) {
  this.AttachFiles.map((item) => {
    apiData.append('files', item);
  });
  }

   this._api.functionPOST('task/sendTaskMessage', apiData).subscribe((response) => {
     if (response.success) {
      //  this.addButton=false;
      this.newMessage = '';
      this._api.openSnackBar('Success', 'Success');
      this.AttachFiles = [];
      this.pageNo =1;
      this.getTaskDetails();

    }
    // this.addButton=false;
  }, err => {
    // this.addButton=false;
  });
  this.spinner.hide();
}

backToCurrentBuisness() {
  const stateData = { tab: 3};
    this.router.navigate(['/current_business'], { state: stateData });
}

}

